import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Button, Dropdown } from '../../components';

@Component
export default class Pagination extends Vue {

  @Prop() page!: number;
  @Prop() pages!: number;
  @Prop() pageSize!: number;
  @Prop() canPrevious!: boolean;
  @Prop() totalRecordLength!: number;
  @Prop() restorePageNumber!: number;
  @Prop() pageSizeOptions!: string[];
  @Prop() canNext!: boolean;
  @Prop() width!: number;

  pageUpdated: boolean = false;
  minWidth: number = 0;

  defaultTablePageSizeOptions: string[] = ['25', '50', '100'];
  oldPage: number = 0;

  render(): JSX.Element {
    const { pages, pageSize, canPrevious, totalRecordLength, restorePageNumber, pageSizeOptions } = this;
    const defaultTablePageSize = pageSizeOptions ? pageSizeOptions : this.defaultTablePageSizeOptions;

    let { page, canNext } = this;
    if (restorePageNumber && !this.pageUpdated) {
      if (page === this.oldPage) {
        this.oldPage = page;
        page = 0;
      }
    }
    canNext = canNext === false && page === 0 ? true : canNext;
    const visiblePages: number[] = this._getVisiblePages(page + 1, pages);
    const activePage: number = page + 1;
    const firstRecord: number = page * pageSize;
    let lastRecord: number = firstRecord + pageSize;
    const totalRecords: number = totalRecordLength;
    lastRecord = lastRecord >= totalRecordLength ? totalRecordLength : lastRecord;
    const dropdownOptions: any = [
      { displayText: defaultTablePageSize[0], itemId: defaultTablePageSize[0], selectable: true },
      { displayText: defaultTablePageSize[1], itemId: defaultTablePageSize[1], selectable: false },
      { displayText: defaultTablePageSize[2], itemId: defaultTablePageSize[2], selectable: false },
    ];
    const showDropdown: boolean = totalRecords > Number.parseInt(defaultTablePageSize[0], 10) ? true : false;
    const showPages: boolean = pages > 1;

    return (
      <div class='tl-pagination-wrapper' id='lazy'>
        <div class='page-info'>
          <span class='pagination-text-count'>
            {`${firstRecord + 1}-${lastRecord}`}{' '}
          </span>
          <span class='pagination-text-light'>{'of'} </span>
          <span class='pagination-text-bold'>{`${totalRecords}`} </span>
          <span class='pagination-text-light pagination-records'>
            {'Items per page'}
          </span>

          {showDropdown && <div class='pagination-dropdown'>
            <Dropdown
              dropdownId='dropdownId'
              value={pageSize}
              assistiveText='Description text'
              options={dropdownOptions}
              onOptionClick={(e: any) =>
                this._onPageSizeValChange(Number.parseInt(e.target.id.substring(0, 3), 10))
              }
            />
          </div>}
        </div>
        { showPages && <div class='pg-button-wrapper text'>
          <Button
            onClick={() => {
              if (!canPrevious) { return; }
              this._changePage(page - 1);
            }}
            variant='primary'
            iconPosition='left'
            disabled={!canPrevious}
            size='small'
            icon='icon-system-arrow1-left'
          >
            {this.width > this.minWidth ? 'Previous' : ''}
          </Button>
          {visiblePages.map((p: number, index: number, array: number[]) => {
            return (
              <div>
                {array[index - 1] + 2 <= p ? (
                  <div class='tl-pg-range-dot'>...</div>
                ) : (
                    ''
                  )}
                <Button
                  onClick={() => this._changePage(p - 1)}
                  variant='secondary'
                  size='small'
                  className={
                    'tl-pagination-item' + (activePage === p ? ' tl-pagination-selected' : '')
                  }
                  disabled={activePage === p}
                >
                  {p}
                </Button>
              </div>
            );
          })}
          <Button
            onClick={() => {
              if (!canNext) { return; }
              this._changePage(page + 1);
            }}
            disabled={!canNext}
            variant='primary'
            size='small'
          >
            {this.width > this.minWidth ? 'Next' : ''}
          </Button>
        </div>}
      </div>

    );
  }

  @Emit()
  onPageChange(page: number): void {
    this.$emit('pageChange', page);
  }

  @Emit()
  onPageSizeChange(page: number): void {
    this.$emit('pageSizeChange', page);
  }

  private _getSafePage(page: number): number {
    if (Number.isNaN(page)) {
      page = this.page;
    }
    return Math.min(Math.max(page, 0), this.pages - 1);
  }

  private _changePage(page: number): void {
    const nextPage: number = this._getSafePage(page);
    this.pageUpdated = false;
    this.onPageChange(nextPage);
  }

  private _filterPages(visiblePages: number[], totalPages: number): number[] {
    return visiblePages.filter((page) => page <= totalPages);
  }

  private _getVisiblePages(page: number, total: any): number[] {
    total = Number.parseInt(total, 10);
    if (total < 7) {
      return this._filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  }

  private _onPageSizeValChange(page: number): void {
    setTimeout(() => {
      this._changePage(0);
    }, 50);
    this.onPageSizeChange(page);
  }

}
